/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geomapsubtitle2Inputs */

const en_geomapsubtitle2 = /** @type {(inputs: Geomapsubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where Pulsify is being used, aggregated and anonymized.`)
};

const de_geomapsubtitle2 = /** @type {(inputs: Geomapsubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo Pulsify genutzt wird, aggregiert und anonymisiert.`)
};

/**
* | output |
* | --- |
* | "Where Pulsify is being used, aggregated and anonymized." |
*
* @param {Geomapsubtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geomapsubtitle2 = /** @type {((inputs?: Geomapsubtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geomapsubtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geomapsubtitle2(inputs)
	return de_geomapsubtitle2(inputs)
});
export { geomapsubtitle2 as "geoMapSubtitle" }